import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

const JobLeadsDashboard = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [form, setForm] = useState({ name: "", email: "", password: "" });

  useEffect(() => {
    axios
      .get("https://api.theleadsense.com/api/v1/job/leadsense")
      .then((response) => {
        if (response.data.status === 200 && !response.data.error) {
          const dataWithId = response.data.data.infomation.map(
            (item, index) => ({
              ...item,
              id: item.id || index + 1,
            })
          );
          setLeads(dataWithId);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const filteredLeads = leads.filter(
    (item) =>
      (item.name || "").toLowerCase().includes(filterText.toLowerCase()) ||
      (item.email || "").toLowerCase().includes(filterText.toLowerCase()) ||
      (item.phone || "").toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    {
      name: "",
      cell: () => <></>,
      width: "50px",
      ignoreRowClick: true,
    },
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      width: "80px",
      sortable: true,
    },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Phone", selector: (row) => row.phone },
    { name: "Program", selector: (row) => row.program },
    { name: "Cohort", selector: (row) => row.cohort },
    {
      name: "Experience (Yrs)",
      selector: (row) => row.total_work_experience,
      sortable: true,
    },
    { name: "Current CTC", selector: (row) => row.current_ctc },
    { name: "Expected CTC", selector: (row) => row.expected_ctc },
    {
      name: "CV",
      cell: (row) => (
        <a
          href={row.cv_url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#2563eb", fontWeight: 600 }}
        >
          View
        </a>
      ),
    },
    {
      name: "Video",
      cell: (row) => (
        <a
          href={row.video_url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#2563eb", fontWeight: 600 }}
        >
          Watch
        </a>
      ),
    },
    { name: "Created Date", selector: (row) => row.cdate },
  ];

  const handleShareClick = () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one row to share.");
      return;
    }
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: form.name,
      email: form.email,
      password: form.password,
      phone: selectedRows[0]?.phone || "",
      array: JSON.stringify(selectedRows.map((data) => data?.id)),
    };

    try {
      await axios.post("https://api.theleadsense.com/api/v1/company/user", payload, {
        headers: { "Content-Type": "application/json" },
      });
      alert("Leads shared successfully!");
    } catch (error) {
      console.error("Share API Error:", error);
      alert("Failed to share leads.");
    }

    setShowModal(false);
  };

  return (
    <div
      style={{
        padding: "24px",
       
        minHeight: "100vh",
      }}
    >
      <h2 style={{ fontSize: "22px", fontWeight: 700, marginBottom: "20px" }}>
        Job Leads
      </h2>

      <div style={{ display: "flex", marginBottom: "16px", gap: "20px" }}>
        <button
          onClick={handleShareClick}
          style={{
            backgroundColor: "#2563eb",
            color: "white",
            padding: "10px 18px",
            borderRadius: "8px",
            border: "none",
            fontWeight: 600,
            cursor: "pointer",
            boxShadow: "0 4px 10px rgba(37, 99, 235, 0.3)",
          }}
        >
          Share Selected
        </button>

        <input
          type="text"
          placeholder="Search by Name, Email or Phone"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={{
            flex: 1,
            padding: "10px 14px",
            borderRadius: "8px",
            border: "1px solid #d1d5db",
            fontSize: "14px",
          }}
        />
      </div>

      <div
        style={{
          background: "white",
          padding: "18px",
          borderRadius: "12px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
        }}
      >
        <DataTable
          columns={columns}
          data={filteredLeads}
          progressPending={loading}
          pagination
          paginationPerPage={5}
          highlightOnHover
          striped
          responsive
          selectableRows
          persistTableHead
          onSelectedRowsChange={({ selectedRows }) =>
            setSelectedRows(selectedRows)
          }
        />
      </div>

      {/* Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "24px",
              borderRadius: "12px",
              width: "380px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
            }}
          >
            <h3 style={{ marginBottom: "16px", fontSize: "18px", fontWeight: 600 }}>
              Share Selected Leads
            </h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Your Name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "12px",
                  borderRadius: "8px",
                  border: "1px solid #d1d5db",
                }}
              />

              <input
                type="email"
                placeholder="Email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "12px",
                  borderRadius: "8px",
                  border: "1px solid #d1d5db",
                }}
              />

              <input
                type="password"
                placeholder="Password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "16px",
                  borderRadius: "8px",
                  border: "1px solid #d1d5db",
                }}
              />

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  style={{
                    backgroundColor: "#e5e7eb",
                    color: "#111827",
                    padding: "8px 14px",
                    borderRadius: "8px",
                    border: "none",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  style={{
                    backgroundColor: "#2563eb",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    border: "none",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Share
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobLeadsDashboard;
